"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const Picasso_1 = require("../Picasso");
const styles_2 = require("../styles");
const setBorderColor = (borderColor) => styles_2.createPropertiesStyles({
    '&:before': {
        borderColor
    }
});
const setCircleColor = (borderColor) => styles_2.createPropertiesStyles({
    '&:after': {
        borderColor,
        display: 'block'
    }
});
const createColorVariant = (mainColor, disabledColor) => styles_2.createPropertiesStyles({
    '&$checked': Object.assign({}, setBorderColor(mainColor), setCircleColor(mainColor)),
    '&$disabled': Object.assign({ opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'auto' }, setBorderColor(disabledColor)),
    '&:hover': Object.assign({}, setBorderColor(mainColor))
});
Picasso_1.PicassoProvider.override(({ palette, transitions }) => ({
    MuiRadio: {
        root: Object.assign({ fontSize: '16px', position: 'relative', width: '1em', height: '1em', padding: '0', margin: '0.25em 0.5em 0.25em 0' }, createColorVariant(palette.primary.main, palette.grey[300]), { animationDuration: `${transitions.duration.short}`, animationTimingFunction: transitions.easing.easeIn, transitionDuration: `${transitions.duration.short}`, transitionTimingFunction: transitions.easing.easeOut }),
        disabled: createColorVariant(palette.grey[300], palette.grey[300]),
        checked: {}
    }
}));
const centeredCircle = (palette) => styles_2.createPropertiesStyles({
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '50%',
    left: '50%',
    borderRadius: '50%',
    transform: 'translate(-50%, -50%)',
    content: '""',
    borderColor: 'inherit',
    background: palette.common.white,
    pointerEvents: 'none',
    transition: 'border-color',
    transitionDuration: 'inherit',
    transitionTimingFunction: 'inherit'
});
exports.default = ({ palette }) => styles_1.createStyles({
    '@keyframes fade-in': {
        '0%': {
            opacity: 0
        },
        '100%': {
            opacity: 1
        }
    },
    icon: {
        '&:before': Object.assign({}, centeredCircle(palette), { border: `1px solid ${palette.common.black}` }),
        '&:after': Object.assign({}, centeredCircle(palette), { width: 'initial', height: 'initial', borderWidth: '0.25em', borderStyle: 'solid', display: 'none', animation: 'fade-in', animationDuration: 'inherit', animationTimingFunction: 'inherit' })
    },
    label: {
        marginRight: '0.5em'
    }
});
//# sourceMappingURL=styles.js.map